import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  // verifyEmail,
  logoutUser,
  resetPassword,
  resetPasswordLink,
  resetPasswordLinkVerification,
} from "../../thunks/authenticationThunk";
import storage from "redux-persist/lib/storage";

interface AuthenticationState {
  loginLoading: Boolean;
  resetPasswordLinkLoading: Boolean;
  resetPasswordLinkVerificationLoading: Boolean;
  resetPasswordLoading: Boolean;
  logoutUserLoading: Boolean;
  userInfo: object | null;
  error: any;
  response: any;
  success: Boolean;
  loggedIn: Boolean;
  previousLocation: string;
}
const initialState: AuthenticationState = {
  loginLoading: false,
  resetPasswordLinkLoading: false,
  resetPasswordLinkVerificationLoading: false,
  resetPasswordLoading: false,
  logoutUserLoading: false,
  userInfo: {},
  loggedIn: false,
  error: null,
  response: null,
  success: false,
  previousLocation: "",
};
export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.clear();
      state.loginLoading = false;
      state.resetPasswordLinkLoading = false;
      state.resetPasswordLinkVerificationLoading = false;
      state.resetPasswordLoading = false;
      state.logoutUserLoading = false;
      state.userInfo = null;
      state.error = null;
      state.loggedIn = false;
      state.success = false;
      state.previousLocation = "";
      storage.removeItem("persist:root");
    },
    reset: (state) => {
      state.error = null;
      state.success = false;
      state.response = null;
    },
    setPreviousLocation: (state, action) => {
      state.previousLocation = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(loginUser.pending, (state) => {
      state.loginLoading = true;
      state.loggedIn = false;
      state.error = null;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.loginLoading = false;
      state.loggedIn = action.payload?.result;
      state.userInfo = action.payload;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loginLoading = false;
      state.loggedIn = false;
      state.error = action.payload;
    });

    builder.addCase(resetPasswordLink.pending, (state) => {
      state.resetPasswordLinkLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(resetPasswordLink.fulfilled, (state, action) => {
      state.resetPasswordLinkLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(resetPasswordLink.rejected, (state, action) => {
      state.resetPasswordLinkLoading = false;
      state.success = false;
    });

    builder.addCase(resetPasswordLinkVerification.pending, (state) => {
      state.resetPasswordLinkVerificationLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(
      resetPasswordLinkVerification.fulfilled,
      (state, action) => {
        state.resetPasswordLinkVerificationLoading = false;
        state.success = true;
        state.response = action.payload;
      }
    );
    builder.addCase(resetPasswordLinkVerification.rejected, (state, action) => {
      state.resetPasswordLinkVerificationLoading = false;
      state.success = false;
    });

    builder.addCase(resetPassword.pending, (state) => {
      state.resetPasswordLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.resetPasswordLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.resetPasswordLoading = false;
      state.success = false;
    });

    builder.addCase(logoutUser.pending, (state) => {
      state.logoutUserLoading = true;
      state.loggedIn = false;
      state.error = null;
    });
    builder.addCase(logoutUser.fulfilled, (state, action) => {
      state.logoutUserLoading = false;
      state.loggedIn = false;
      state.userInfo = null;
    });
    builder.addCase(logoutUser.rejected, (state, action) => {
      state.logoutUserLoading = false;
      state.loggedIn = false;
      state.error = action.payload;
    });
    // builder.addCase(registerUser.pending, (state) => {
    //   state.loading = true;
    //   state.success = false;
    // });
    // builder.addCase(registerUser.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.success = true;
    //   state.response = action.payload;
    // });
    // builder.addCase(registerUser.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
    // builder.addCase(verifyEmail.pending, (state) => {
    //   state.loading = true;
    //   state.success = false;
    // });
    // builder.addCase(verifyEmail.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.success = true;
    //   state.response = action.payload;
    // });
    // builder.addCase(verifyEmail.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
  },
});

export const { logout, reset, setPreviousLocation } =
  authenticationSlice.actions;

export const authenticationReducer = authenticationSlice.reducer;
